import { Card, Box, Skeleton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { white, blackText } from '../../Constants';

interface RecipeCardSkeletonProps {
  count?: number;
}

function SingleSkeleton() {
  return (
    <Card
      sx={{
        width: '100%',
        maxWidth: 380,
        borderRadius: 3,
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: white,
        overflow: 'hidden',
        border: '1px solid',
        borderColor: alpha(blackText, 0.06),
      }}
    >
      {/* Image Skeleton */}
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          aspectRatio: '4/3',
          width: '100%',
        }}
      />

      {/* Content */}
      <Box sx={{ p: 2.5, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Title */}
        <Skeleton variant="text" width="85%" height={28} animation="wave" sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width="60%" height={28} animation="wave" sx={{ mb: 1.5 }} />

        {/* Meta Row */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 'auto' }}>
          <Skeleton variant="text" width={70} height={24} animation="wave" />
          <Skeleton variant="text" width={100} height={24} animation="wave" />
        </Box>
      </Box>
    </Card>
  );
}

export default function RecipeCardSkeleton({ count = 1 }: RecipeCardSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <SingleSkeleton key={index} />
      ))}
    </>
  );
}
